import type { TOC } from '@ember/component/template-only';
import { array, fn } from '@ember/helper';
import { or } from 'ember-truth-helpers';
import SettingsBudgetForecastSettingsPage from 'lumen/components/settings/budget-forecast/settings-page';
import type HotelSettingsForecastDetailController from 'lumen/controllers/hotel/settings/forecast/detail';

interface HotelSettingsForecastDetailSignature {
  Args: {
    controller: HotelSettingsForecastDetailController;
    model: unknown;
  };
}

<template>
  <SettingsBudgetForecastSettingsPage
    @budgetForecastItems={{@controller.budgetForecastItems}}
    @capacities={{@controller.model.capacities.last.value}}
    @endDate={{@controller.endDate}}
    @entries={{or @controller.model.entries.last.value (array)}}
    @entry={{or @controller.model.entry.last.value null}}
    @expandedRowIds={{@controller.expandedRowIds}}
    @granularity={{@controller.granularity}}
    @isLoading={{or
      @controller.model.entry.isRunning
      @controller.model.dataItems.isRunning
      @controller.model.segments.isRunning
      @controller.model.capacities.isRunning
    }}
    @isLoadingVersions={{@controller.model.versions.isRunning}}
    @layoutSettings={{@controller.layoutSettings}}
    @onCollapseAllRows={{@controller.onCollapseAllRows}}
    @onRowCollapseToggle={{@controller.onRowCollapseToggle}}
    @onVarianceChange={{fn (mut @controller.variance)}}
    @reloadData={{@controller.doRefresh}}
    @segmentItems={{or @controller.model.segments.last.value (array)}}
    @selectedVersionId={{@controller.versionId}}
    @startDate={{@controller.startDate}}
    @updateLayoutSettings={{@controller.updateLayoutSettings}}
    @variance={{@controller.variance}}
    @view="forecast"
  />
</template> satisfies TOC<HotelSettingsForecastDetailSignature>;
